export default function GuideHero() {
  return (
    <section className="relative bg-gradient-to-br from-[#8B2635] to-[#6B1A28] text-white pt-32 pb-20">
      <div className="absolute inset-0 bg-gradient-to-b from-black/20 via-black/10 to-black/20"></div>
      <div className="max-w-7xl mx-auto px-6 relative z-10">
        <div className="text-center max-w-3xl mx-auto">
          <h1 className="text-5xl font-bold mb-6">Auction Guide</h1>
          <p className="text-xl text-white/90 leading-relaxed">
            Everything you need to know about buying and selling on Hammerly. 
          </p>
        </div>
      </div>
    </section>
  );
}